"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePath = void 0;
var peggy = require("peggy");
var grammar = "\n// Documentation, specifically for parsing delimited lists.\n// https://peggyjs.org/documentation#parsing-lists\n\n// A path is a dot delimeted list of identifiers.\npath = head:segment tail:(\".\" @segment)* { return [head, ...tail]; }\n\n// Segments consist of an identifier and an optional index.\n// e.g. hello or hello[world]\nsegment = $(identifier index?)\n\n// An identifier is a string of consecutive characters not consisting of dots, quotes or brackets. \nidentifier = [^'\"\\[\\]\\.]+\n\n// An index consists of square brackets containing a quoted or unquoted value.\n// e.g. hello['world'] or hello[world]\nindex = \"[\" $( unquoted_index / single_quoted_index / double_quoted_index) \"]\"\n\nunquoted_index = [^'\"\\]\\[]+\nsingle_quoted_index = \"'\" [^']+ \"'\"\ndouble_quoted_index = '\"' [^\"]+ '\"'\n";
exports.parsePath = createPathParser();
function createPathParser() {
    var parser = peggy.generate(grammar);
    return function (expr) {
        try {
            return parser.parse(expr);
        }
        catch (e) {
            return expr.split('.');
        }
    };
}
//# sourceMappingURL=path.js.map